const mutations = {
  SET_SEARCH_RESULT(state, IOSummarySearchResult) {
    state.searchResult = IOSummarySearchResult
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  UPDATE_SORT_OPTIONS(state, { sortBy, descending }) {
    state.sortOptions.sortBy = sortBy
    state.sortOptions.descending = descending
  },
  UPDATE_SERVE_STATUS_FILTER(state, serveStatus) {
    state.filter.serveStatus = serveStatus
  },
  SET_KEYWORD_FILTER(state, keyword) {
    state.filter.keyword = keyword
  },
  SET_PAGE(state, { pageSize, pageNo }) {
    state.page = { pageSize, pageNo }
  },
}

export default mutations
